/* eslint-disable import/no-named-as-default-member */
import { useEffect, useState } from 'react';
import axios from 'axios';
import { instance } from '@/utils';

interface AxiosResponse {
  find(arg0: (item: any) => boolean): unknown;
  bookingCode: AxiosResponse | null;
  data: any;
  status: number;
  statusText: string;
}

const useAxios = (isLoading = false) => {
  const [response, setResponse] = useState<AxiosResponse | any>('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState<boolean>(isLoading || false);

  useEffect(() => {
    const source = axios.CancelToken.source();
    return () => {
      source.cancel('Component unmounted: Request cancelled.');
    };
  }, []);

  const fetchData = async ({
    url,
    method,
    data = undefined,
    params = undefined,
    headers = null,
    loading = true,
  }: any) => {
    setLoading(loading);
    try {
      const result: any = await instance({
        url,
        method,
        data,
        params,
        headers,
        cancelToken: axios.CancelToken.source().token,
      });
      setResponse(result);
      return result;
    } catch (error: any) {
      if (axios?.isCancel(error)) {
        console.error('Request cancelled', error.message);
      }
      setError(error?.response ? error?.response?.data : error?.message);
      return error?.response ? error?.response?.data : error?.message;
    } finally {
      setLoading(false);
    }
  };
  return { response, error, loading, fetchData };
};

export default useAxios;
